import Vue from 'vue';
import VueRouter from 'vue-router';
import UserService from '../services/user.service';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Welcome',
      documentTitle: '*pages.dashboard.title',
      public: true,
      guestOnly: true,
    },
    component: () => import(/* webpackChunkName: "auth" */ '@/views/Auth/Login.vue'),
  },
  {
    path: '/password/email',
    name: 'password.email',
    meta: {
      title: 'Forgot Password',
      documentTitle: '*forgot-pwd.title',
      public: true,
      guestOnly: true,
    },
    component: () => import(/* webpackChunkName: "auth" */ '@/views/Auth/ForgotPassword.vue'),
  },
  {
    path: '/password/reset',
    name: 'password.reset',
    meta: {
      title: 'Reset Password',
      documentTitle: '*reset-pwd.title',
      public: true,
      guestOnly: true,
    },
    component: () => import(/* webpackChunkName: "auth" */ '@/views/Auth/ResetPassword.vue'),
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      title: 'Dashboard',
      documentTitle: '*pages.dashboard.title',
    },
    component: () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue'),
  },
  // deepltranslations Project Page
  {
    path: '/deepltranslations',
    name: 'deepltranslations',
    meta: {
      title: 'DeepLTranslations',
      documentTitle: '*pages.deepltranslations.title',
    },
    component: () => import('@/views/DeepLTranslationsProject.vue'),
  },
  // deepltranslations Page
  {
    path: '/deepltranslations/:id',
    name: 'deepltranslations-project',
    meta: {
      title: 'Projects Keys',
      documentTitle: '*pages.deepltranslations.title',
      empty: true,
    },
    component: () => import('@/views/DeepLTranslations.vue'),
  },
  // Automated deepltranslations Project Page
  {
    path: '/automateddeepltranslations',
    name: 'automateddeepltranslations',
    meta: {
      title: 'Automated DeepLTranslations',
      documentTitle: '*pages.automateddeepltranslations.title',
    },
    component: () => import('@/views/AutomatedDeepLProject.vue'),
  },
  // Automated deepltranslations Page
  {
    path: '/automateddeepltranslations/:id',
    name: 'automateddeepltranslations-project',
    meta: {
      title: 'Automated DeepLTranslations',
      documentTitle: '*pages.automateddeepltranslations.title',
    },
    component: () => import('@/views/AutomatedDeepLTranslations.vue'),
  },
  {
    path: '/users',
    name: 'users',
    meta: {
      title: 'Users & Roles',
      documentTitle: '*pages.users.title',
      empty: true,
    },
    component: () => import(/* webpackChunkName: "users" */ '@/views/Users.vue'),
  },
  {
    path: '/projects',
    name: 'projects',
    meta: {
      title: 'Projects',
      documentTitle: '*pages.projects.title',
      empty: true,
    },
    component: () => import('@/views/Projects.vue'),
  },
  {
    path: '/projects/:id/keys',
    name: 'projects-keys',
    meta: {
      title: 'Projects Keys',
      empty: true,
    },
    component: () => import('@/views/ProjectKeys.vue'),
  },
  {
    path: '/projects/:id/translations',
    name: 'projects-translations',
    meta: {
      title: 'Projects Keys',
      empty: true,
    },
    component: () => import('@/views/ProjectPageTranslations.vue'),
  },
  {
    path: '/projects/:id/pages',
    name: 'projects-pages',
    meta: {
      title: 'Projects Pages',
      empty: true,
    },
    component: () => import('@/views/ProjectPage.vue'),
  },
  {
    path: '/languages',
    name: 'languages',
    meta: {
      title: 'Languages',
      documentTitle: '*pages.languages.title',
      empty: true,
    },
    component: () => import(/* webpackChunkName: "payments" */ '@/views/Languages.vue'),
  },
  {
    path: '/translators',
    name: 'translators',
    meta: {
      title: 'Translators',
      documentTitle: '*pages.translators.title',
      empty: true,
    },
    component: () => import(/* webpackChunkName: "payments" */ '@/views/Users.vue'),
  },
  {
    path: '/projects/:id/all-translations',
    name: 'projects-all-translations',
    meta: {
      title: 'Projects Keys',
      empty: true,
    },
    component: () => import('@/views/ProjectTranslations.vue'),
  },
  {
    path: '/search-page',
    name: 'searchPage',
    meta: {
      title: 'Search',
      empty: true,
    },
    component: () => import('@/views/SearchPage.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkExactActiveClass: 'exact-active',
  linkActiveClass: 'active',
  routes,
});

export default router;

export { router };

let initialUserCheckDone = false;

let $store = null;
const checkLoggedIn = () => new Promise((resolve) => {
  Vue.nextTick(async () => {
    // save $store for future use
    $store = router.app.$store;
    await $store.dispatch('user/getUser');
    resolve();
  });
});

router.beforeEach(async (to, from, next) => {
  // eslint-disable-next-line no-underscore-dangle
  const _next = next;
  // eslint-disable-next-line no-param-reassign
  next = function newnext(loc) {
    return _next(loc);
  };
  if (!initialUserCheckDone) {
    await checkLoggedIn();
    initialUserCheckDone = true;
  }

  // clear server-validation states in store modules
  $store.dispatch('clearErrors');

  // By default all routes are protected for users only
  const isPublic = to.matched.some((r) => r.meta.public);
  const isLoggedIn = !!await UserService.getUser();

  // prevent guests from visiting logged-in pages
  if (!isPublic && !isLoggedIn) {
    const toLogin = { name: 'login' };
    return next(toLogin);
  }
  return next();
});
